export function getIndexByProximity(elements: NodeListOf<HTMLDivElement>, e: DragEvent) {
  let hoverIndex = -1
  let minDistance = Infinity
  for (let i = 0; i < elements.length; i++) {
    if (!elements[i].classList.contains('dragable'))
      continue
    const distance = Math.abs(elements[i].getBoundingClientRect().top - e.clientY)
    const isHover = distance <= minDistance
    if (isHover) {
      hoverIndex = i
      minDistance = distance
    }
  }

  const onTop = e.clientY < elements[hoverIndex].getBoundingClientRect().top + elements[hoverIndex].getBoundingClientRect().height / 2

  return { hoverIndex, onTop }
}
